import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Decimal } from 'decimal.js';
import { Input } from '@web/utils/src';
import { CartItem } from '@agrantis/cart';

interface Props {
  cartItem: CartItem;
  quantity?: number;
  onAmountChange: (data: { amount: number }) => void;
}

const AmountPicker: React.FC<Props> = ({
  cartItem,
  onAmountChange,
  quantity,
}) => {
  const { t } = useTranslation();

  const [amountText, setAmountText] = useState(
    quantity?.toString() ?? cartItem?.amount.toString() ?? '',
  );

  const onQuantityChange = (text: string) => {
    const value = text.replace(/[- #*;,.]/gi, '');

    setAmountText(value);
    const amount = parseFloat(value || '0');
    onAmountChange({ amount });
  };

  const unit = cartItem?.itemData.unit ?? null;
  const amount = parseInt(amountText) ? new Decimal(parseInt(amountText)) : 0;
  const totalQuantity = unit
    ? new Decimal(cartItem!.itemData.quantity).mul(amount)
    : null;

  return (
    <div className="flex items-center rounded-lg h-9 px-3.5 mb-4 relative">
      <Input
        value={amountText}
        onChange={(_, val) => onQuantityChange(val.toString())}
        type="text"
        data-testid="quantity_input"
        showClear={false}
      />
      {unit && (
        <span className="font-light text-body1 text-gray-600 right-2-0 absolute">
          {`${totalQuantity} ${unit}`}
        </span>
      )}
    </div>
  );
};

export default AmountPicker;
